import { createContext } from 'react'

const IncidentContext = createContext()

export default IncidentContext
